export const COLORS = {
  I: '#3cc7d6',
  O: '#fbb414',
  T: '#b04497',
  J: '#3993d0',
  L: '#ed652f',
  S: '#95c43d',
  Z: '#e84138'
};

// The Shapes and their rotation was inspired from
// http://tetris.wikia.com/wiki/SRS
// TODO: Convert to objects
export const SHAPES = {
  I: [[0, 0, 0, 0], [1, 1, 1, 1], [0, 0, 0, 0], [0, 0, 0, 0]],
  O: [[1, 1], [1, 1]],
  T: [[0, 1, 0], [1, 1, 1], [0, 0, 0]],
  J: [[1, 0, 0], [1, 1, 1], [0, 0, 0]],
  L: [[0, 0, 1], [1, 1, 1], [0, 0, 0]],
  S: [[0, 1, 1], [1, 1, 0], [0, 0, 0]],
  Z: [[1, 1, 0], [0, 1, 1], [0, 0, 0]]
};



// WEBPACK FOOTER //
// ./src/constants/tetromino.js